export default __webpack_public_path__ + "static/media/hay_icon.3b82d9b4.png";